module.exports = __webpack_public_path__ + "static/media/unauthorized_change_img.9ca6aee1.svg";